<template>
    <div class="record-container" v-if="recordList.length > 0">
        <div class="line"></div>
        <div class="status">
            <div class="line"></div>
            <div class="status-desc">领取记录</div>
            <div class="line"></div>
        </div>

        <div class="list" v-for="(item, index) in recordList" :key="index">
            <div class="desc">{{ item.title }}</div>
            <div class="time">{{ item.updateTime | dateFormat('Lll') }}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'record',
    props: {
        recordList: {
            type: Array,
            default: [
                { desc: '领取一张提前还清免息费券', time: '2020-02-19' },
                { desc: '领取一张提前还清免息费券', time: '2020-02-19' },
                { desc: '领取一张提前还清免息费券', time: '2020-02-19' },
                { desc: '领取一张提前还清免息费券', time: '2020-02-19' }
            ]
        }
    },
    data() {
        return {};
    },
    methods: {}
};
</script>
<style lang="less" scoped>
@import '~@common/style/common.less';
.record-container {
    margin-top: 22px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    margin-bottom: 40px;
    .line {
        width: 100%;
        height: 6px;
        background-color: #f5f6f8;
    }
    .status {
        display: flex;
        align-content: center;
        align-items: center;
        flex-direction: row;
        justify-content: center;
        margin-top: 20px;
        margin-bottom: 35px;
        .line {
            background-color: #e3ba8a;
            width: 20px;
            height: 2px;
            display: inline-block;
            margin-left: 10px;
            margin-right: 10px;
        }
        .status-desc {
            display: inline-block;
            font-size: 16px;
            font-family: FZLTHDemiBold--GB1-4-YS, FZLTHDemiBold--GB1-4;
            font-weight: bold;
            color: rgba(41, 39, 56, 1);
            line-height: 18px;
        }
    }

    .list {
        margin-left: 28px;
        margin-right: 28px;
        display: flex;
        justify-content: space-between;
        margin-top: 14px;
        .desc {
            .f-13-bold();
            color: rgba(164, 167, 179, 1);
            line-height: 16px;
        }
        .time {
            .f-13-bold();
            color: rgba(164, 167, 179, 1);
            line-height: 16px;
        }
    }
}
</style>
